var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916666 2.29167C0.916666 2.04855 1.01324 1.81539 1.18515 1.64349C1.35706 1.47158 1.59022 1.375 1.83333 1.375H4.58333V9.625H1.83333C1.59022 9.625 1.35706 9.52842 1.18515 9.35651C1.01324 9.18461 0.916666 8.95145 0.916666 8.70833V2.29167ZM6.41667 1.375H9.16667C9.40978 1.375 9.64294 1.47158 9.81485 1.64349C9.98676 1.81539 10.0833 2.04855 10.0833 2.29167V4.58333H6.41667V1.375ZM6.41667 6.41667H10.0833V8.70833C10.0833 8.95145 9.98676 9.18461 9.81485 9.35651C9.64294 9.52842 9.40978 9.625 9.16667 9.625H6.41667V6.41667Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e21deaad79d1bab3c77f500fa722464d.svg";
export { ForwardRef as ReactComponent };